<template>
  <v-col
    cols="12"
    md="auto"
    lg="auto"
    class="d-flex align-center justify-center"
  >
    <div class="pa-5 fill-height how-to-play">
      <v-row class="d-flex flex-column">
        <v-col class="d-flex flex-row pa-0">
          <v-col class="pt-0">
            <v-img contain :src="item.src" height="55px" width="60px"></v-img>
          </v-col>
          <v-col class="py-0">
            <span
              class="h4 white--text d-flex justify-end"
              style="line-height: unset"
              >0{{ item.num }}'</span
            >
          </v-col>
        </v-col>
        <v-col cols="9" class="d-flex flex-column py-0">
          <span class="h4 white--text" style="line-height: unset !important">
            {{ item.title }}
          </span>
        </v-col>
        <v-col cols="8">
          <span class="white--text d-block text-wrap" style="width: 200px">
            {{ item.text }}
          </span>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "InstructionCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>